import { render, staticRenderFns } from "./DeCanvas.vue?vue&type=template&id=36b30650"
import script from "./DeCanvas.vue?vue&type=script&lang=js"
export * from "./DeCanvas.vue?vue&type=script&lang=js"
import style0 from "./DeCanvas.vue?vue&type=style&index=0&id=36b30650&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36b30650')) {
      api.createRecord('36b30650', component.options)
    } else {
      api.reload('36b30650', component.options)
    }
    module.hot.accept("./DeCanvas.vue?vue&type=template&id=36b30650", function () {
      api.rerender('36b30650', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/canvas/DeCanvas.vue"
export default component.exports